import { render, staticRenderFns } from "./ColorCalendar.vue?vue&type=template&id=1dd1eb91&scoped=true"
import script from "./ColorCalendar.vue?vue&type=script&lang=js"
export * from "./ColorCalendar.vue?vue&type=script&lang=js"
import style0 from "./ColorCalendar.vue?vue&type=style&index=0&id=1dd1eb91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd1eb91",
  null
  
)

export default component.exports